import * as React from "react";
import { Button } from "@twilio/flex-ui/node_modules/@twilio-paste/core/node_modules/@twilio-paste/button";
import { Text } from "@twilio/flex-ui/node_modules/@twilio-paste/core/node_modules/@twilio-paste/text";
import uhaulStore from "../CustomRedux/UhaulStore";
import { Spinner } from "@twilio/flex-ui/node_modules/@twilio-paste/core/node_modules/@twilio-paste/spinner"
import ExceptionLogger from "../ExceptionHelper";
import { Box } from '@twilio/flex-ui/node_modules/@twilio-paste/box'
import { WorkersDataTableSelectionRow } from "./WorkerDataTable/WorkersDataTableSelectionRow"
import { WorkersDataTableSelectionColumnHeader } from "./WorkerDataTable/WorkersDataTableSelectionColumnHeader"
import { ColumnDefinition } from "@twilio/flex-ui/node_modules/@twilio/flex-ui-core";
import { Manager } from "@twilio/flex-ui";
import fetchWorkerProfileInfo from "../WorkerProfileHelper";

export class MarkOfflineButton extends React.Component {
    constructor(props) {
        super(props);

        if(props.flex){
            props.flex.WorkersDataTable.Content.add(<ColumnDefinition
                key="WorkersDataTableSelectionColumnDefinition"
                header={<WorkersDataTableSelectionColumnHeader/>}
                content={(items, context) => <WorkersDataTableSelectionRow items={items}/>}/>, {sortOrder: -1});
        }
    }

    logAgentsOut = () => {
        let currentUser = uhaulStore.getState().UhaulReducer.currentUser;
        let serviceBaseUrl = currentUser.serviceBaseUrl;
        let supervisorSmid = currentUser?.friendlyName ?? "";
        var selectedWorkers = [], fetchInProgress = false;
        var checkboxes = document.getElementsByName("chkStatus");

        if(checkboxes?.length)
        {
            for (const checkbox of checkboxes) {
                if (checkbox.checked) {
                    selectedWorkers.push({
                        "workerId": checkbox.getAttribute("data-workerid"),
                        "sid": checkbox.getAttribute("data-workerid")
                    });
                }
            }
        }

        if (selectedWorkers?.length) {
            fetchInProgress = true;

            var fn = function getReservations(worker) {
                const workerSid = worker.sid != null ? worker.sid : (worker.workerId != null ? worker.workerId : "");

                fetchWorkerProfileInfo(serviceBaseUrl, workerSid).then(({ smid }) => {
                    ExceptionLogger(null, "logAgentsOut",
                        `Supervisor ${supervisorSmid} marked agent ${smid ?? workerSid} offline`,
                        "", { supervisor: supervisorSmid, workerSid: workerSid, agentSmid: smid }, true);
                });

                return new Promise(resolve => setTimeout(() => resolve(
                    fetch(serviceBaseUrl + "change-status",
                        {
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            },
                            method: "POST",
                            body: new URLSearchParams({
                                Token: Manager.getInstance().user.token,
                                WorkerSID: workerSid
                            })
                        })
                        .then(() => {
                            console.log("Status Changed.");
                        }).catch((err) => {
                            console.log("Fetch ERROR: ", err);

                            //only record actual errors and not "options" call from api
                            const hasNoNetworkError = err?.message
                                && !err.message.includes("NetworkError when attempting to fetch resource.")
                                && !err.message.includes("Failed to fetch")

                            if(hasNoNetworkError)
                            {
                                ExceptionLogger(err, "logAgentOut", "Error with ChangeStatus", "",`${worker.workerId != null ? worker.workerId : ""}`);
                            }
                        })
                ), 100));
            };

            var actions = selectedWorkers.map(fn);
            var results = Promise.all(actions);
            results.then(() => {
                fetchInProgress = false;
            });
        }
        else {
            console.log("No workers were selected. Please refresh and try again.");
        }

        return(fetchInProgress ? <Spinner /> : null);
    }

    render() {
        return (

                <Box
                    as="div"
                    paddingLeft="space100"
                    paddingTop="space100">
                    <Button
                        variant="primary"
                        id="btnLogAgentOut"
                        className="supervisorBtn"
                        onClick={this.logAgentsOut}>
                            <Text color="white">Mark as Offline</Text>
                    </Button>
                </Box>
        )
    }
}
